<template>
  <div class="ll-empty-pic" :style="{ marginTop: marginTop + 'px' }">
    <p v-if="bigTitle" class="ll-empty-pic_big-title">
      {{ $t(bigTitle) }}
    </p>
    <img :src="image" alt="" class="ll-empty-pic_img" />
    <p class="ll-empty-pic_title">
      {{ $t(title) }}
    </p>
    <p v-if="content" class="ll-empty-pic_content">
      {{ $t(content) }}
    </p>
    <div v-if="btnText" class="ll-empty-pic_btn">
      <WsButton001
        :leading-icon="btnIcon"
        :primary="isPrimary"
        :out-line="isOutline"
        @click="$_btnClick()"
      >
        {{ $t(btnText) }}
      </WsButton001>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LlEmptyPic',
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    marginTop: {
      type: Number,
      default: 40,
    },
    btnIcon: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '',
    },
    isPrimary: {
      type: Boolean,
      default: false,
    },
    isOutline: {
      type: Boolean,
      default: false,
    },
    bigTitle: {
      type: String,
      default: '',
    },
  },
  methods: {
    $_btnClick() {
      this.$emit('btn-click');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-empty-pic';
</style>
